export class CustomDateTimeEditor {
  init(params) {
    this.params = params;
    this.eInput = document.createElement('input');
    this.eInput.type = 'datetime-local';

    // Apply AG Grid theme variables for styling and size containment
    
    this.eInput.style.boxSizing = 'border-box'; // Crucial for height and width management
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%'; // Make it fill the cell's height

    // Apply AG Grid classes for consistent styling and behavior, which might be crucial for Quartz theme.
    this.eInput.classList.add('ag-input-field-input', 'ag-text-field-input');
    

    let initialValue = params.value;
    if (initialValue) {
      const date = new Date(initialValue);
      if (!isNaN(date.getTime())) {
        // Format date to YYYY-MM-DDTHH:mm as required by datetime-local
        // datetime-local does not handle seconds or milliseconds, so they are truncated.
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        this.eInput.value = `${year}-${month}-${day}T${hours}:${minutes}`;
      }
    }

    this.eInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        params.stopEditing();
      } else if (event.key === 'Escape') {
        params.stopEditing(true); // true to cancel changes
      }
    });
  }

  getGui() {
    return this.eInput;
  }

  afterGuiAttached() {
    this.eInput.focus();
    // You might want to call this.eInput.select() if you want to select the text
  }

  getValue() {
    const value = this.eInput.value;
    if (value) { // value will be like "2024-05-28T17:30"
      try {
        // Attempt to parse the input value and convert to ISO string
        const date = new Date(value);
        if (isNaN(date.getTime())) {
          // Handle cases where new Date(value) results in an "Invalid Date"
          console.error('CustomDateTimeEditor.getValue: Input resulted in an invalid date:', value);
          return null;
        }
        return date.toISOString(); // Convert to ISO 8601 UTC string
      } catch (error) {
        // Catch errors from new Date(value) or .toISOString() (e.g., RangeError)
        console.error('CustomDateTimeEditor.getValue: Error parsing or converting date:', value, error);
        return null; // Return null if any error occurs during parsing/conversion
      }
    }
    return null; // If input is empty, represent as null
  }

  isPopup() {
    return false; // Display the editor inline
  }

  destroy() {
    // Perform any cleanup tasks here, if necessary
  }
}
